import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Texts, Media } from "../index";

class Button extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slug: props.slug,
      link: props.link,
      linkType: props.linkType,
      type: props.type,
      child: props.children,
      class: "c-button",
      innerClass: props.innerClass,
    };


    this.Inner = this.Inner.bind(this);
  }

  Inner = () => {
    if (this.state.child) {
      return this.state.child;
    } else {
      return (
        <>
          <div className="c-text__wrap--text">
            {/* <div
              className="c-button__img--arrow"
              data-state={this.state.type}
            /> */}
            <Texts
              slug={"button/" + this.state.slug}
              class={
                this.state.innerClass ? this.state.innerClass : "c-text--bold c-text--white"
              }
            />
          </div>
        </>
      );
    }
  };

  Scroll = (props) => {
    setTimeout(() => {
      let margin = 126;
      const rect = props.getBoundingClientRect();
      const target = rect.top - window.pageYOffset;
      scrollTo({
        top: target,
        left: 0,
        behavior: "smooth",
      });
    }, 800);
  };

  render() {
    if (this.state.linkType == "hash") {
      return (
        <HashLink
          smooth
          to={this.state.link}
          className={this.state.child ? "" : "c-button"}
          data-state={this.state.type}
          scroll={(el) => this.Scroll(el)}
        >
          <this.Inner />
        </HashLink>
      );
    } else {
      return (
        <Link
          to={this.state.link}
          className={this.state.child ? "" : "c-button"}
          data-state={this.state.type}
        >
          <this.Inner />
        </Link>
      );
    }
  }
}

export default Button;
